// extracted by mini-css-extract-plugin
export default {"buttonAssign":"AssignDeviceButton_buttonAssign__lJ+JT"};